import styled from "styled-components";

export const Root = styled.div`
  padding-top: 105px;

  &.mobile {
    padding-top: 88px;

    .top {
      flex-direction: column;
      margin-top: 0;
      padding-bottom: 20px;

      .pic {
        margin-right: 0;

        img {
          width: 100%;
        }
      }

      .detail {
        margin-top: 20px;

        h1 {
          font-size: 18px;
        }

        .desc {
          margin-top: 15px;
          line-height: 16px;
          font-size: 12px;
        }

        .info {
          margin-top: 20px;

          span {
            font-size: 12px;
          }
        }

        .user {
          font-size: 12px;

          img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }
      }
    }

    .content {
      padding: 0 12px;
    }

    .news {
      li {
        margin-top: 20px;
      }
    }
  }

  .top {
    display: flex;
    align-items: center;
    margin-top: 88px;
    padding-bottom: 60px;
    border-bottom: 1px solid #eee;

    .pic, .detail h1, .detail .desc {
      cursor: pointer;
    }

    .pic {
      margin-right: 45px;

      img {
        width: 665px;
        display: block;
        border-radius: 10px;
      }
    }

    .detail {
      h1 {
        font-size: 26px;
      }

      .desc {
        margin-top: 40px;
        line-height: 20px;
        font-size: 16px;
        color: #666666;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient:vertical;
      }

      .info {
        margin-top: 75px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999;

        span {
          font-size: 14px;
        }
      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;

        img {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }

  .news {
    li {
      margin-top: 60px;
    }
  }
`

export const DetailRoot = styled.div`
  padding-top: 105px;

  .main {
    display: flex;
    align-items: flex-start;
    margin-top: 40px;
  }

  .main-wrapper {
    width: 775px;
    margin-right: 135px;
    flex-shrink: 0;
  }

  .navs {
    flex: 1;
    overflow: hidden;
    padding-left: 1px;
    position: sticky;
    top: 20px;
    /* top: 135px; */

    ul {
      border-left: 1px solid #ccc;
      padding: 12px 0;
    }

    li {
      margin-bottom: 25px;
      padding-left: 40px;
      line-height: 26px;
      font-size: 16px;
      color: #999;
      position: relative;
      left: -2px;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &:last-child {
        margin-bottom: 0;
      }

      &.on, &:hover {
        color: #C02C16;
      }

      &.on {
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 3px;
          width: 3px;
          height: 20px;
          background-color: #C02C16;
          border-radius: 3px;
        }
      }
    }
  }

  .top {
    .pic {
      img {
        width: 100%;
        display: block;
        border-radius: 10px;
      }
    }

    .detail {
      h1 {
        margin-top: 54px;
        line-height: 42px;
        font-size: 36px;
      }

      .info {
        margin-top: 30px;
        display: flex;
        align-items: center;
        color: #999;

        span {
          font-size: 14px;
        }

        .line {
          width: 1px;
          height: 16px;
          background-color: #999;
          margin: 0 15px;
        }
      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: #666666;

        img {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
    }
  }

  .content {
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #eee;
    line-height: 26px;
    font-size: 16px;

    h2 {
      margin-top: 40px;
    }

    p {
      margin-bottom: 20px;
    }
  }

  .bottom {
    padding-top: 0;
  }
`
